import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const DEPO_NAME_DOMAIN = "DNAME"

export type DepoName = {
    name: string
}

const prepareDepoNames  = ( response : DepoName[]   ) => {
    const opts: OptionCl[] = response.map( (dname : DepoName) => ({
        id : dname.name,
        description: dname.name
    })
    )
    return opts;
}


// depository names for the depository dropdown
export const fetchDepoNames = (
    dispatch : Dispatch<any>,
    componentType: "DepositoryCriteria"
) => {
    api
        .post("/codelist/v1/Depository/depnames")
        .then( (response:AxiosResponse) => {
            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                const depoNames : DepoName[] = response.data.Depository; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareDepoNames(depoNames), domain: DEPO_NAME_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
